import { ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import {
  NB_AUTH_OPTIONS,
  NbAuthResult,
  NbAuthService,
  NbAuthSocialLink,
} from '@nebular/auth';
import { NbDateService, NbThemeService } from '@nebular/theme';
import { Subject } from 'rxjs';
import { filter, takeUntil } from 'rxjs/operators';
import { environment } from '../../../../environments/environment';
import { RolesData } from '../../../@core/interfaces/common/roles';
import { UserData } from '../../../@core/interfaces/common/users';
import { PatientRegistrationData } from '../../../@core/interfaces/patient-services/patient-registration';
import { DateService } from '../../../@theme/components/common/service/date.service';
import { InitUserService } from '../../../@theme/services/init-user.service';
import { getDeepFromObject } from '../../helpers';
import { NUMBERS_PATTERN } from '../constants';
import { PatientAppointmentData } from '../../../@core/interfaces/patient-services/patient-appointment';
import * as gender from './../../../data/gender.json';
import * as title from './../../../data/title.json';
import { INgxSelectOption } from 'ngx-select-ex';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';

@Component({
  selector: 'ngx-patientportallogin',
  templateUrl: './patientportallogin.component.html',
  styleUrls: ['./patientportallogin.component.scss','../../../../assets/css/patient-portal.css']
})
export class PatientportalloginComponent implements OnInit {
  protected readonly unsubscribe$ = new Subject<void>();
  notUser:boolean=false;
  loginForm: FormGroup;
  minLength: number = this.getConfigValue('forms.validation.password.minLength');
  maxLength: number = this.getConfigValue('forms.validation.password.maxLength');
  redirectDelay: number = this.getConfigValue('forms.login.redirectDelay');
  showMessages: any = this.getConfigValue('forms.login.showMessages');
  strategy: string = this.getConfigValue('forms.login.strategy');
  socialLinks: NbAuthSocialLink[] = this.getConfigValue('forms.login.socialLinks');
  rememberMe = this.getConfigValue('forms.login.rememberMe');
  isEmailRequired: boolean = this.getConfigValue('forms.validation.email.required');
  isPasswordRequired: boolean = this.getConfigValue('forms.validation.password.required');
  isTenantIdRequired: boolean = this.getConfigValue('forms.validation.tenantId.required');
  isUserNameRequired: boolean = this.getConfigValue('forms.validation.userName.required');
  isMobileNumberRequired: boolean = this.getConfigValue('forms.validation.fullName.required');
  genderList: string[] = (gender as any).default;
  titleList: any = (title as any).default;
  isNewPatientLink: boolean = false;
  isNewDoctorLink: boolean = false;
  messages: any[];
  errors: any[];
  submitted: boolean;
  user: any; 
  loginResult: any;
  data: Array<any>=[];
  loginUserAuthorized: boolean=false;
  accessToken: string;
  loginData: any;
  OTPid: any;
  phoneNumber: any;
  smscontent: string;
  sendthroughsms: boolean;
  templateData: any;
  isOtpDia: boolean;
  otpForm: FormGroup;
  mobileVerifyPopUp: boolean=false;
  isSuccess: boolean=false;
  isFailure: boolean=false;
  resetForm: FormGroup;
  passWordChange: boolean=false;
  bookingPlatFormApp: FormGroup;
  isForgotPassword: boolean;
  isUserLogin: boolean;
  resetMobileNum: any;
  isResetComp: boolean;
  userAlreadyExists: boolean;
  customer:boolean=true;
  isSubmitted: boolean;
  isAppointmentSaved: boolean;
  invalidbookingPlatFormAppForm: boolean;
  get fullName() { return this.loginForm.get('fullName'); }
  get password() { return this.loginForm.get('password'); }
  isLogin:boolean = true;
  forgetPass:boolean=false;
  @ViewChild("digit1") d1Element: ElementRef;
  @ViewChild("digit2") d2Element: ElementRef;
  @ViewChild("digit3") d3Element: ElementRef;
  @ViewChild("digit4") d4Element: ElementRef;
  @ViewChild("digit5") d5Element: ElementRef;
  @ViewChild("digit6") d6Element: ElementRef;
  @ViewChild("verifybtn") verifyBtnElement: ElementRef;
  tenatId = environment.patientTenantId;
  cusId = environment.patientCusID;
  branchId=environment.patientBranchId
  signUp :boolean = false;
  patientDetails:Array<any>=[];
  patientLists:Array<any>=[];
  userList:Array<any>=[];
  placeholder:string="Select";
  maxDobDate:Date;
  newPassFlag:boolean=false;
  countryCodeDropDownLists: Array<any> = [];
  mobileMinlength: number;
  mobileMaxlength: number;
  private countryCode = localStorage.getItem('LoginCountryCode');
  page:string="location"; // "signup" or "location"
  appointmentBookingPath:string;
  isAppointmentBooking:boolean=false;
  isPatientDoc:boolean=false;
  countryDetail:any={};
  countryName:string;
  nearByCity:string;
  nearByRegion:string;
  lastFourDigits:any;
  cc:string;
  isParam:boolean=false;

  constructor(
    protected service: NbAuthService,
    @Inject(NB_AUTH_OPTIONS) protected options = {},
    protected cd: ChangeDetectorRef,
    protected themeService: NbThemeService,
    private fb: FormBuilder,
    private patSrvc: PatientRegistrationData, 
    protected router: Router,
  private route: ActivatedRoute,protected rolesService: RolesData,protected userService: UserData,public DatService:DateService,protected initUserService: InitUserService,private getDrAppointmentService: PatientAppointmentData,protected dateService: NbDateService<Date>,protected http:HttpClient,private patAptSrv: PatientAppointmentData,private location: Location) { }

    get apiUrl(): string {
      return environment.apiUrl;
     }

  ngOnInit(): void {
    this.isNewPatientLink = false;
    const mobileNumberValidators = [
      Validators.pattern(NUMBERS_PATTERN),
    ];
    const passwordValidators = [
      Validators.pattern(NUMBERS_PATTERN),
      Validators.minLength(8),
      Validators.maxLength(16),
    ];
    this.resetForm = this.fb.group({
      password: this.fb.control('',[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')]),
      confirmPassword : this.fb.control('',[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')])
    })
    this.bookingPlatFormApp = this.fb.group({
      mobile: this.fb.control(null,[Validators.required]),
      firstName: this.fb.control(null,[Validators.required,Validators.pattern('^[\\u0020-\\u007E\\u00C0-\\u02AF\\u0370-\\u1FFF\\u2C00-\\uD7FF\\u0B80-\\u0BFF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\s]+$')]),
      lastName: this.fb.control(null,[Validators.pattern('^[\\u0020-\\u007E\\u00C0-\\u02AF\\u0370-\\u1FFF\\u2C00-\\uD7FF\\u0B80-\\u0BFF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\s]+$')]),
      dob: this.fb.control(null,[Validators.required]),
      gender:this.fb.control(null,[Validators.required]),
      title:this.fb.control(null,[Validators.required]),
      pass:this.fb.control(null,[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')]),
      confirmPass:this.fb.control(null,[Validators.required,Validators.pattern('^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[$@$!%*?&])[A-Za-z\\d$@$!%*?&]{7,}$')]),
      mobileCountryCode: this.fb.control(null,[Validators.required]) 
    });

    this.loginForm = this.fb.group({
      fullName: this.fb.control('', [...mobileNumberValidators, Validators.minLength(this.mobileMinlength), Validators.maxLength(this.mobileMaxlength)]),
      password: this.fb.control('',  ),
      rememberMe: this.fb.control(''),
      tenantId: this.fb.control(''),
      branchId: this.fb.control(''),
    });
    localStorage.setItem('responseTenantId', this.tenatId);

    var regID=localStorage?.getItem("regID");
    if(regID!=null){
      // this.router.navigateByUrl("pages/patient-portal/landing/"+regID);
    }
    this.otpForm = this.fb.group({
      digit1: this.fb.control('', [Validators.pattern('^[0-9-]+$'), Validators.maxLength(1), Validators.minLength(1)]),
      digit2: this.fb.control(''),
      digit3: this.fb.control(''),
      digit4: this.fb.control(''),
      digit5: this.fb.control(''),
      digit6: this.fb.control(''),
    });
    this.otpForm.get("digit1").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d2Element.nativeElement.focus());
    this.otpForm.get("digit2").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d3Element.nativeElement.focus());
    this.otpForm.get("digit3").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d4Element.nativeElement.focus());
    this.otpForm.get("digit4").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d5Element.nativeElement.focus());
    this.otpForm.get("digit5").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.d6Element.nativeElement.focus());
    this.otpForm.get("digit6").valueChanges
    .pipe(filter((value: string) => value.length === 1))
    .subscribe(() => this.verifyBtnElement.nativeElement.focus());
  
    this.maxDobDate = this.dateService.addDay(this.dateService.today(), 0);

    this.route.queryParams.subscribe(params => {
    if (params['cc']) {
      this.cc = params['cc']; 
      this.isParam = true  
    } else {
      this.detectUserCountry();
    }
  });
  }
  onSignupClose(data: any): void   {
    this.isNewPatientLink = false;
    
  }
  get fval() { return this.bookingPlatFormApp.controls; }

  onDocotrSignupClose(data: any): void   {
    this.isNewDoctorLink = false;    
  }
  getConfigValue(key: string): any {
  
    return getDeepFromObject(this.options, key, null);
  }


  newPatient()
  {
    this.isNewPatientLink = true;
  }

  onVerify() {

    let otp = "";
    otp += this.otpForm.get('digit1').value;
    otp += this.otpForm.get('digit2').value;
    otp += this.otpForm.get('digit3').value;
    otp += this.otpForm.get('digit4').value;
    otp += this.otpForm.get('digit5').value;
    otp += this.otpForm.get('digit6').value;
    if (otp != "") {
      if (otp == this.OTPid) {
        this.isSuccess = true;
        this.isFailure = false;
        this.isLogin=false;
        this.forgetPass=false;
        this.newPassFlag=true;
        this.mobileVerifyPopUp = false;
      }
      else {
        this.isFailure = true;
        this.isSuccess = false;
      }
    }
  }

  otpFormClose(){
    this.mobileVerifyPopUp=false; 
    this.otpForm.reset({
      digit1: '',
      digit2: '',
      digit3: '',
      digit4: '',
      digit5: '',
      digit6: '',
    });
  }

  gotoBooking(routingPath){
    this.appointmentBookingPath=routingPath;
    this.isAppointmentBooking = true;
    if(routingPath == 'doc') this.isPatientDoc = localStorage.getItem('isPatientDoc') === 'true';
  }
  verifyMobileIsexist() {
    this.errors = [];
      let data={
        "PatientMobile":this.loginForm.get('fullName').value
      }
      this.lastFourDigits=this.loginForm.get('fullName').value?.toString().slice(-4);
      this.getDrAppointmentService.searchList(`bookingPlatform/checkIsPatientExists`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(returnData => {
        if(!!returnData?.user){  
          this.notUser=false;
          this.phoneNumber = this.loginForm.get('fullName').value;
          if(!!this.phoneNumber && this.phoneNumber!=undefined){
        
          this.userService.getBranchList(`users/mobile/${this.phoneNumber}/${environment.virtualTenant}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
            if(!!data){
              this.getotpsms();
            }
          }, (error) => {

          }, () => {
          
          });
          }
        }else{
          this.notUser=true;

        }

      })
       

  }
  
  verifyPass(event){
    
    event.target.disabled = true;
    if(this.resetForm.valid && (this.resetForm.get('password').value == this.resetForm.get('confirmPassword').value)){
      const det = {
        Password: this.resetForm.get('password')?.value,
        ConfirmPassword: this.resetForm.get('password')?.value,
        MobileNumber: this.phoneNumber
      }
      this.http.post(environment.apiUrl+'/auth/updatePassword',det).pipe(takeUntil(this.unsubscribe$)).subscribe(()=>{
        this.resetForm.reset();
        event.target.disabled = false;
        this.newPassFlag=false;
        this.passWordChange = true;
        setTimeout(()=>{this.passWordChange = false;},4000)
        this.isLogin=true;
        this.isSuccess = true;
      });

    }else{
      event.target.disabled = false;
    }
  }

  getotpsms(){
    let data = {
      "headers": {
        "Accept": "application/vnd.ezovion.hateoas+json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    }
    this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${environment.virtualTenant}/sendotp/${this.phoneNumber}`,data).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
     this.OTPid=data;
      // this.checksmspossibility();
    }, (error) => {
    }, () => {
      this.mobileVerifyPopUp = true;
    });
  }

  // To check sms send or not based on credit limit and template purchase based:-
  checksmspossibility(){
    let templateData;
    let istemplatepurchase;
    this.rolesService.list(`patientportalnewuser/${environment.virtualTenant}/${environment.virtualBranch}/TemplateDet`).subscribe(data => {
      templateData=data;
      if(!!data){
        this.smscontent="Ezovion employees never ask for OTP. Sharing it with anyone allows unauthorized access to your Ezovion account. Your OTP is " + this.OTPid + ". It will be valid for 2 minutes only. Thanks, Ezovion.";
          istemplatepurchase = templateData.sms.purchasedTemplateDet.filter(x =>x.commonTemplateMstDet?.smsTemplateNameMst?.templateName.toLocaleLowerCase() == "ezovion-otp")
          if(istemplatepurchase?.length>0){
            if(istemplatepurchase.length-1>-1){ 
              if(istemplatepurchase[istemplatepurchase.length-1]?.creditBalance > 0){
                this.sendthroughsms=true; 
                this.templateData=istemplatepurchase[istemplatepurchase.length-1];
                this.sendSMS(istemplatepurchase[istemplatepurchase.length-1]);  
              }
            }
          
            else{
              this.sendthroughsms=false; 
            }
          }
          else{
            this.sendthroughsms=false; 
          }
          this.isOtpDia = true;
          this.cd.detectChanges();
          // this.otpVerifyInstance.fromforgotPassword("forgotPassword")
      }
    }, (error) => {
    }, () => {
    });
  }

  
  // To send sms for registration save and update:-
  sendSMS(templateData){
    let smstrackingDetails={
      referencefrom:"ezovion otp",
      referencenum:'0',
      mobileNumber:this.phoneNumber,
      dateTime:this.DatService.currentDate(),
      message:this.smscontent,
      smsUnit:1,
      senderId:templateData.smsgatewaysettingsDet.serviceName,
      status:"ok",
      templateId:templateData.commonTemplateMstDet.templateDetId,
      createdIp:null,
      createdby:parseInt(localStorage.getItem("userId")),
      createddate:this.DatService.currentDate(),
      tenantId:this.tenatId,
      branchId:this.branchId
    }
    
    let smsContent={
      text:this.smscontent,
      mobile:this.phoneNumber,
      apiURL:templateData.smsgatewaysettingsDet.providerUrl,
      apiKey:templateData.smsgatewaysettingsDet.providerKey,
      route:templateData.smsgatewaysettingsDet.serviceType,
      senderId:templateData.smsgatewaysettingsDet.serviceName,
      tenantId:this.tenatId,
      branchId:this.branchId,
      smstrackingDetails:smstrackingDetails,
      tenantApiConfigId:templateData?.tenantApiConfigId,
    }
    this.rolesService.create(`${this.apiUrl}/patientportalnewuser/${environment.virtualTenant}/sendSMS`, smsContent).subscribe(data => {
    }, (error) => {
    }, () => {
      this.mobileVerifyPopUp = true;
    });
  }

  onRequestPasswordClose(data: any): void {
    if (data == null) {
      this.isForgotPassword = false;
      this.isUserLogin = true;
    }
    else if (data.otpVerified == "approved" || data.otpVerified == "success") {
      this.isSuccess = true;
      this.otpForm.reset();
      this.isFailure = false;
      this.isLogin=false;
       this.forgetPass=false;
      this.mobileVerifyPopUp = false;
      this.resetMobileNum = data.resetMobileNum;
      this.isForgotPassword = false;

      this.isResetComp = true;
    }

  }


   loginCreate(): void {
    this.submitted=true;
    this.loginForm.controls["tenantId"].setValue(environment.virtualTenant.toLowerCase());
    this.loginForm.controls["branchId"].setValue(environment.virtualBranch.toLowerCase());  
    this.user = this.loginForm.value;  
    this.errors = [];
    this.messages = [];
    this.submitted = true;
    const auth ={
      "fullName": "9500672785",
      "password": "Ezovion@1",
      "rememberMe": "",
      "tenantId": "6b5d5bf1-e369-4b5d-e9b3-08dacd6f38e4",
      "branchId": "4e54f59e-226b-42a3-8ef2-cda3ac8fc727"
  }
    // this.patSrvc.post(`auth/loginForMobile`,auth).subscribe((data)=> {      

    //   const det = data
    // })
    this.service.authenticate("email", this.user).subscribe((result: NbAuthResult) =>
    {  
    // this.patSrvc.post(`auth/loginForMobile`,auth).subscribe((result)=> {
      this.submitted = false;
      this.loginResult =result;
      if (result.isSuccess()) {
        this.messages = result.getMessages();
        this.initUserService.initCurrentUser().subscribe();
        this.userAlreadyExists = false;
        var searchData={
          "searchWord": this.user.fullName,
          "fromDate": null,
          "toDate": null,
          "skip": 0,
          "take": 100
      };
        this.patSrvc.searchList("patientregistrationmst/" + environment.virtualTenant + '/' + environment.virtualBranch + '/search', searchData).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {    
          var regID=data[0]?.id;
              var firstName=data[0]?.firstname;
              // window.localStorage.setItem("regID",data[0]?.id);
              localStorage.setItem("loginuser","patientlogin");
              localStorage.setItem("regID",regID);
              localStorage.setItem("patientMobNo",this.user.fullName);
              localStorage.setItem("patientName",firstName);
              this.submitted=false;
              localStorage.setItem('cc', this.cc);
              return this.router.navigate(['/pages/patient-portal/landing']);
          });
      } else {
      
        // this.router.navigate(['auth/patient-portal']);
        if(result.getResponse().status == 403){
          this.errors.push("Your account has been disabled, Please see your administrator");
        }
        else{
          this.errors.push("Incorrect credentials. Try again.");
          return this.router.navigate(['/auth/patient-portal']);
        }

      
      }


      this.cd.detectChanges();
    });
  }

  numberOnly(event): boolean {
    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    this.checkIsExists(event);
    return true;

  }
  checkIsExists(event){


    if(event.target.value.length>=10){
      let data={
        "PatientMobile":event.target.value
      }
      event.target.disabled = true;
      this.getDrAppointmentService.searchList(`bookingPlatform/checkIsPatientExists`, data).pipe(takeUntil(this.unsubscribe$)).subscribe(returnData => {
       
        this.patientLists = [];
        this.userList = [];
         const formControlsToUpdate = ['firstName','lastName','dob', 'gender','title'];
          formControlsToUpdate.forEach(key => {
            this.bookingPlatFormApp.controls[key]?.reset();
            this.bookingPlatFormApp.controls[key]?.enable();
          });
        
        // Check if the patient alone exists
        if (returnData.patient.length !== 0 && returnData.user == null) {
          this.patientDetails = returnData?.patient;
           this.bookingPlatFormApp.get('firstName')?.setValue(this.patientDetails[0]?.firstname);
            this.bookingPlatFormApp.get('firstName')?.disable();
           this.bookingPlatFormApp.get('lastName')?.setValue(this.patientDetails[0]?.lastname);
            this.bookingPlatFormApp.get('lastName')?.disable();
          const formControlsToUpdate = ['dob', 'gender','title'];
          formControlsToUpdate.forEach(key => {
            this.bookingPlatFormApp.controls[key]?.setValue(this.patientDetails[0]?.[key]);
            this.bookingPlatFormApp.controls[key]?.disable();
          });
              
          this.userAlreadyExists = false;
        }
        // Check if both patient and user exist
        else if (!!returnData.patient && returnData.user != null) {
          this.userAlreadyExists = true;
          // this.openLoginPopup = true;
          this.signUp = false;
          this.loginForm.get('fullName').setValue(event.target.value);
          this.patientLists = returnData.patient;
          this.userList = returnData.user;
        } 
        //when neither patient nor user exist
        else {
          this.userAlreadyExists = false;
          // this.openLoginPopup = false;
         // this.customer = false;
         this.bookingPlatFormApp.get('firstName')?.enable();
         this.bookingPlatFormApp.get('lastName')?.enable();
         this.bookingPlatFormApp.get('dob')?.enable();
        //  this.bookingPlatFormApp.get('gender')?.enable();
        }}, (error) => {
      }, () => {
        event.target.disabled = false;
      });
    }
    
      }

      saveAppBooking(fromLogin?){

        if(this.bookingPlatFormApp.valid && this.bookingPlatFormApp?.get('pass')?.value === this.bookingPlatFormApp?.get('confirmPass')?.value || !!fromLogin){
          this.isSubmitted=true;
          let newData=new Date( this.bookingPlatFormApp.get('dob').value);
          const today = new Date();
      
          var Difference_In_Time = Math.abs(Date.now() - newData.getTime());
          var Difference_In_Days = Math.ceil(Difference_In_Time / (1000 * 3600 * 24));
          var ageValue = Difference_In_Days / 365.25;
          const year = (Math.round(ageValue));
          const fullname=this.bookingPlatFormApp.get('firstName').value+(this.bookingPlatFormApp.get('lastName').value ?''+this.bookingPlatFormApp.get('lastName').value:'');
          let requestData ={
              branchId: environment.virtualBranch,
              email: null,
              fName:  this.bookingPlatFormApp.get('firstName').value,
              lName: null,
              mobileNum: this.bookingPlatFormApp.get('mobile').value,
              tenantId: environment.virtualTenantID,
              fullName: fullname,
              userFlag: "Patient",
              title: this.bookingPlatFormApp.get('title').value,
              gender: this.bookingPlatFormApp.get('gender').value,
              age: year,
              loginUserType: "patientlogin",
              password: this.bookingPlatFormApp.get('pass').value,
              confirmPassword: this.bookingPlatFormApp.get('confirmPass').value
            }
            this.http.post(environment.apiUrl+'/auth/sign-upForMobile',requestData).subscribe((res) => {
              this.isAppointmentSaved=true; 
              this.signUp=false;        
              setTimeout(()=>{ this.isAppointmentSaved=false;},4000)
          })
        }
        else{
          this.invalidbookingPlatFormAppForm=true;
        }
     
       
      }

      focustoOpenSelect($event){ 
        $event.optionsOpen()
      }
      tabToClose($event){
        $event.optionsClose()
      }
      onTitleChange(event: INgxSelectOption[]) {
        if (event[0].data.value == "1" || event[0].data.value == "5") {
          this.bookingPlatFormApp.controls['gender'].setValue("Male");
        }
        else if (event[0].data.value == "2" || event[0].data.value == "3" || event[0].data.value == "4") {
          this.bookingPlatFormApp.controls['gender'].setValue("Female");
        }
        this.bookingPlatFormApp.get('gender').disable();      }
      openLogin(){
        this.loginForm.get('fullName').setValue(this.bookingPlatFormApp.get('mobile').value);
        this.signUp=false;
        this.isSubmitted=false;
        this.bookingPlatFormApp.reset();
      }

      loadCountryMaster(): void {
        this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
          this.countryCodeDropDownLists = data.details;
          
        }, (error) => {
          if(error.status==401){
            this.router.navigateByUrl('/auth/patient-portal');
          }
        }, () => {
          this.signUp = true;
        this.bookingPlatFormApp.reset();
        this.invalidbookingPlatFormAppForm = false;
          this.route.queryParams.subscribe(params => {
          if(!!params.cc){
            const countryCode = this.countryCodeDropDownLists.filter(x => x.countryCode == params.cc);
            if(countryCode.length>0){
              this.bookingPlatFormApp.get('mobileCountryCode')?.setValue(countryCode[0]?.id);
            }
          }
    });
        });
      }

      onCountryCodeChange(code , type) {
        if(type=='Mobile'){
            this.mobileMinlength = code[0]?.data?.minMobileNumberLength ;
            this.mobileMaxlength = code[0]?.data?.maxMobileNumberLength ;
            this.bookingPlatFormApp.get('mobile').setValidators([Validators.minLength(this.mobileMinlength) , Validators.maxLength(this.mobileMaxlength)]);
            this.bookingPlatFormApp.get('mobile').updateValueAndValidity(); 
        }}


  onClickProfile(){
    this.isAppointmentBooking = false;
    this.page="signup";
    this.loadCountryMasterForLogin();
  }

  loadCountryMasterForLogin(): void {
    this.patAptSrv.list(`countries/getCountryMasterAnonymous`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
      this.countryCodeDropDownLists = data.details;
      
    }, (error) => {
      if(error.status==401){
        this.router.navigateByUrl('/auth/patient-portal');
      }
    }, () => {
      this.route.queryParams.subscribe(params => {
      if(!!params.cc){
        const countryCode = this.countryCodeDropDownLists.filter(x => x.countryCode == params.cc);
        if(countryCode.length>0){
          this.mobileMinlength = countryCode[0]?.minMobileNumberLength ;
          this.mobileMaxlength = countryCode[0]?.maxMobileNumberLength ;
          // this.bookingPlatFormApp.get('mobileCountryCode')?.setValue(countryCode[0]?.id);
        }
      }
      });
    });
  }

  gotoHome(){
    this.page="location";
    this.isAppointmentBooking = false;
  }

  searchDoctors(){
    this.nearByRegion = this.countryDetail.region;
    this.nearByCity = this.countryDetail.city;
    this.appointmentBookingPath='doc';
    this.isAppointmentBooking = true;
  }

  detectUserCountry() {
    this.http.get<any>('https://ipapi.co/json/').subscribe(res => {
      this.countryDetail = res;
      this.countryName = res.country_name;
    },(error)=>{},()=>{
      if(!this.isParam) {
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { cc: this.countryDetail.country_calling_code },
          queryParamsHandling: 'merge',
          replaceUrl: true      
        });
      }
      this.setCountryCode();
    });
  }

  onClickCountry(countryName){
    this.countryName = countryName;
    this.setCountryCode();
  }

  setCountryCode(){
    this.rolesService.list(`countries/GetCountryByName/${this.countryName}`).pipe(takeUntil(this.unsubscribe$)).subscribe((data: any) => {
        if(!!data){
          this.cc =data?.countryCode
          this.bookingPlatFormApp.get('mobileCountryCode')?.setValue(data?.countryCode);
          this.mobileMinlength = data?.minMobileNumberLength;
          this.mobileMaxlength = data?.maxMobileNumberLength;
          this.bookingPlatFormApp.get('mobile')?.setValidators([
            Validators.required,
            Validators.minLength(data?.minMobileNumberLength),
            Validators.maxLength(data?.maxMobileNumberLength)
          ]);
          this.bookingPlatFormApp.get('mobile')?.updateValueAndValidity();
        }
      },(error)=>{
        if(error.status==401){
          this.router.navigateByUrl('/auth/patient-portal');
        }
      },()=>{
        // if (!this.isParam) {
        //   this.router.navigate([], {
        //   relativeTo: this.route,
        //   queryParams: { cc: this.cc },
        //   queryParamsHandling: 'merge',
        //   replaceUrl: true      
        // });
        // }
      })
  }


  onCreateAccount(){
    this.loadCountryMaster();
  }

  onClickClose(){
    this.signUp = false;
    this.bookingPlatFormApp.reset();
    this.invalidbookingPlatFormAppForm = false;
  }

  scrollToBottom() {
  const scrollStep = 5;  // pixels to scroll each step
  const delay = 10;      // delay in ms between scroll steps

  const scrollInterval = setInterval(() => {
    const { scrollTop, scrollHeight, clientHeight } = document.documentElement;

    if (scrollTop + clientHeight >= scrollHeight) {
      clearInterval(scrollInterval); // stop scrolling when bottom is reached
    } else {
      window.scrollBy(0, scrollStep);
    }
  }, delay);
}

}
